class LpMirror6078 {
  constructor(element) {
    this.element = element;
    this.product = JSON.parse(element.querySelector('[data-lp-product]').textContent);
    this.currency = element.dataset.currency || 'RON';
    this.controller = new AbortController();
    this.busy = false;
    this.variant = this.product.variants.find((item) => item.id === Number(element.querySelector('input[name="id"]').value));
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    const options = { signal: this.controller.signal };
    element.addEventListener('change', this.handleChange, options);
    element.addEventListener('click', this.handleClick, options);
    element.addEventListener('submit', this.handleSubmit, options);
    window.addEventListener('popstate', () => this.selectFromUrl(), options);
    this.selectFromUrl();
    const video = element.querySelector('video');
    if (video) {
      video.muted = true;
      video.loop = true;
      this.videoObserver = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !video.closest('[hidden]')) {
          if (video.readyState < 2) video.load();
          video.play().catch(() => {});
        } else video.pause();
      }, { threshold: 0.15 });
      this.videoObserver.observe(video);
    }
    this.observer = new IntersectionObserver(([entry]) => {
      element.querySelector('[data-lp-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, { threshold: 0.1 });
    this.observer.observe(element.querySelector('[data-lp-primary]'));
  }

  static init(root = document) {
    root.querySelectorAll('[data-lp-mirror-6078]').forEach((element) => {
      if (!element.lpMirror6078) element.lpMirror6078 = new LpMirror6078(element);
    });
  }

  money(cents) {
    return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: this.currency, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100).replace(/RON/g, 'lei');
  }

  selectFromUrl() {
    const id = Number(new URL(window.location.href).searchParams.get('variant'));
    this.selectVariant(this.product.variants.find((variant) => variant.id === id)?.id || this.variant.id, false);
  }

  selectVariant(id, updateUrl = true) {
    const variant = this.product.variants.find((item) => item.id === Number(id));
    if (!variant) return;
    this.variant = variant;
    this.element.querySelectorAll('[data-lp-variant]').forEach((input) => { input.checked = Number(input.value) === variant.id; });
    this.element.querySelectorAll('[data-lp-select], input[name="id"]').forEach((input) => { input.value = variant.id; });
    this.element.querySelectorAll('[data-lp-price]').forEach((node) => { node.textContent = this.money(variant.price); });
    this.element.querySelectorAll('[data-lp-size]').forEach((node) => { node.textContent = 'Oglindă LED'; });
    this.element.querySelectorAll('[data-lp-cashback]').forEach((node) => { node.textContent = this.money(Math.round(variant.price * 0.05)); });
    this.element.querySelectorAll('[data-lp-stock]').forEach((node) => { node.textContent = variant.available ? 'În stoc · Livrare 2–4 zile lucrătoare' : 'Momentan indisponibil'; });
    this.element.querySelectorAll('[data-lp-variant-price]').forEach((node) => {
      const rowVariant = this.product.variants.find((item) => item.id === Number(node.dataset.lpVariantPrice));
      node.textContent = this.money(rowVariant.price);
    });
    this.updateButtons();
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  updateButtons() {
    this.element.querySelectorAll('[data-lp-add]').forEach((button) => {
      button.disabled = this.busy || !this.variant.available;
      button.setAttribute('aria-busy', String(this.busy));
      if (!button.dataset.initialHtml) button.dataset.initialHtml = button.innerHTML;
      if (this.busy) button.textContent = 'Se adaugă…';
      else if (!this.variant.available) button.textContent = 'Momentan indisponibil';
      else {
        button.innerHTML = button.dataset.initialHtml;
        button.querySelectorAll('[data-lp-size]').forEach((node) => { node.textContent = 'Oglindă LED'; });
        button.querySelectorAll('[data-lp-price]').forEach((node) => { node.textContent = this.money(this.variant.price); });
      }
    });
  }

  handleChange(event) {
    if (event.target.matches('[data-lp-variant], [data-lp-select]')) this.selectVariant(event.target.value);
  }

  handleClick(event) {
    if (event.target.closest('[data-lp-video-show]')) {
      this.element.querySelector('.lp-mirror-6078__gallery-main').hidden = true;
      this.element.querySelector('.lp-mirror-6078__video').hidden = false;
      const video = this.element.querySelector('.lp-mirror-6078__video video');
      video?.play()?.catch(() => {});
      this.element.querySelector('[data-lp-video-show]').hidden = true;
      this.element.querySelectorAll('[data-lp-image]').forEach(button => button.setAttribute('aria-pressed', 'false'));
    }
    const thumbnail = event.target.closest('[data-lp-image]');
    if (thumbnail) {
      const image = this.element.querySelector('.lp-mirror-6078__gallery-main');
      image.hidden = false;
      this.element.querySelector('.lp-mirror-6078__video').hidden = true;
      this.element.querySelector('.lp-mirror-6078__video video')?.pause();
      this.element.querySelector('[data-lp-video-show]').hidden = false;
      image.removeAttribute('srcset');
      image.src = thumbnail.dataset.lpImage;
      image.alt = thumbnail.dataset.lpAlt;
      this.element.querySelectorAll('[data-lp-image]').forEach((button) => button.setAttribute('aria-pressed', String(button === thumbnail)));
    }
    if (event.target.closest('[data-lp-dismiss]')) this.element.querySelector('[data-lp-feedback]').hidden = true;
    const button = event.target.closest('[data-lp-add]');
    if (button && button.type !== 'submit') this.addToCart();
  }

  handleSubmit(event) {
    if (!event.target.matches('.lp-mirror-6078__form')) return;
    event.preventDefault();
    this.addToCart();
  }

  showMessage(message, error = false) {
    const feedback = this.element.querySelector('[data-lp-feedback]');
    feedback.querySelector('[data-lp-message]').textContent = message;
    feedback.querySelector('a').hidden = error;
    feedback.hidden = false;
    feedback.setAttribute('role', error ? 'alert' : 'status');
  }

  async addToCart() {
    if (this.busy || !this.variant.available) return;
    const selected = this.variant;
    this.busy = true;
    this.updateButtons();
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Produsul nu a putut fi adăugat. Încearcă din nou.');
      window.location.assign(`${root}cart`);

    } catch (error) {
      this.showMessage(error.message || 'Conexiunea a fost întreruptă. Verifică coșul înainte să încerci din nou.', true);
    } finally {
      this.busy = false;
      this.updateButtons();
    }
  }

  destroy() {
    this.controller.abort();
    this.observer.disconnect();
    this.videoObserver?.disconnect();
    delete this.element.lpMirror6078;
  }
}

LpMirror6078.init();
document.addEventListener('shopify:section:load', (event) => LpMirror6078.init(event.target));
document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-lp-mirror-6078]').forEach((element) => element.lpMirror6078?.destroy()));








